import axiosConfig from "./axiosConfig";

// Fetches a file through the API client and hands it to the browser as a download.
// A plain link would work in production (Express serves both) but not in dev: the CRA
// proxy refuses navigations that accept text/html and serves the app instead.
const filenameOf = (headers) => {
  const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(headers["content-disposition"] || "");
  return match ? decodeURIComponent(match[1] || match[2]) : "document";
};

const downloadFile = async (url) => {
  const res = await axiosConfig({ url, method: "GET", responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = href;
  link.download = filenameOf(res.headers);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(href);
};

export default downloadFile;
